import { FC } from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import ReservationUnsuccessful from './ReservationUnsuccessful';
import Reserve from './Reserve';

const BookingProcess: FC<RouteComponentProps> = ({ match }) => (
  <Switch>
    <Route path={`${match.url}/reserve`} component={Reserve} />
    <Route path={`${match.url}/reservation-unsuccessful`} component={ReservationUnsuccessful} />
  </Switch>
);

export default BookingProcess;
